import { Grid, Typography } from "@mui/joy";
import React from "react";
import BuildingList, { Building } from "./BuildingList";
import BuildingPage from "./BuildingPage";
import { useParams } from "react-router-dom";
import { Util } from "../Helpers/Util";

interface BuildingPortalProps {}

export default function BuildingPortal(props: BuildingPortalProps) {
	const [selected, setSelected] = React.useState(null as any as Building);
	const [hideList, setHideList] = React.useState(false);
	const u = useParams()["*"];
	const selectBuilding = (b: Building) => {
		setSelected(b);
	};

	return (
		<Grid columnSpacing={1} container sx={{ overflowY: "hidden" }}>
			<Grid xs={hideList ? 0 : 2} sx={{ overflowY: "auto", height: "100%" }}>
				<BuildingList hide={() => setHideList(true)} selectBuilding={selectBuilding} defaultBuilding={u} />
			</Grid>
			<Grid xs={hideList ? 12 : 10} sx={{ overflowY: "hidden", height: "100%", display: "flex", flexDirection: "column" }}>
				{selected && <BuildingPage BuildingID={selected.ID} />}
			</Grid>
		</Grid>
	);
}
